<h1 mat-dialog-title>Promena lozinke</h1>
<form [formGroup]="form">
   <div class="row">
      <div class="col-md-6">
         <p>Trenutna lozinka:</p>
      </div>
      <div class="col-md-6">
         <input class="input" type="password" formControlName="oldPassword" [(ngModel)]="model.oldPassword">
         <!-- <mat-error *ngIf="form.get('oldPassword').hasError('required')">
                     Current password is <strong>required</strong>
                  </mat-error> -->
      </div>
   </div>
   <div class="row">
      <div class="col-md-6">
         <p>Nova lozinka:</p>
      </div>
      <div class="col-md-6">
         <input class="input" type="password" formControlName="newPassword" [(ngModel)]="model.newPassword">
         <!-- <mat-error *ngIf="form.get('newPassword').hasError('required')">
                     New password is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.get('newPassword').hasError('minlength') 
                              && form.get('newPassword').touched">
                     Password must be at least 4 characters
                  </mat-error> -->
      </div>
   </div>

   <div class="row">
      <div class="col-md-6">
         <p>Potvrda nove lozinke:</p>
      </div>
      <div class="col-md-6">
         <input class="input" type="password" formControlName="confirmNewPassword">
         <!-- <mat-error *ngIf="form.get('confirmNewPassword').hasError('required')">
                     Confirm new password is <strong>required</strong>
                  </mat-error>
                  <mat-error *ngIf="form.hasError('mismatch')">
                     Passwords must match
                  </mat-error> -->
      </div>
   </div>
</form>
<div>
   <button mat-button class="btn float-left" (click)="onNoClick()">Poništi</button>
   <button mat-button class="btn btn-warning float-right" (click)="change()">Izmeni</button>
</div>
